import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";

export default function Account() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [address, setAddress] = useState(null);
  const [editAddress, setEditAddress] = useState(false);
  const [addressForm, setAddressForm] = useState({});
  const [editUser, setEditUser] = useState(false);
  const [userForm, setUserForm] = useState({});
  const [selectId, setSelectId] = useState(0);

  const navigate = useNavigate();

  // handleLogout function ાં change કરો
  const handleLogout = (e) => {
    e.preventDefault();
    Swal.fire({
      title: "Are you sure you want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, logout",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("userToken");
        localStorage.removeItem("currentUserId"); // Add this line
        Swal.fire({
          title: "Logged Out!",
          text: "You have been successfully logged out.",
          icon: "success",
          confirmButtonColor: "#3085d6",
        }).then(() => {
          window.location.href = "/"; // Change this line
        });
      }
    });
  };

  // useEffect માં change કરો
  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("userToken");
      if (!token) {
        Swal.fire(
          "Login Required",
          "Please login to proceed to checkout.",
          "info"
        );
        return;
      }

      try {
        // Fetch user info
        const userRes = await axios.get(
          "https://sunrise-backend.sunrisemeditechsystems.com/api/users/myData",
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setUser(userRes.data);
        setUserForm({
          name: userRes.data.name,
          email: userRes.data.email,
          username: userRes.data.username,
          phone: userRes.data.phone,
          area: userRes.data.area,
        });

        // Fetch orders
        const orderRes = await axios.get(
          "https://sunrise-backend.sunrisemeditechsystems.com/api/orders/my-orders",
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setOrders(orderRes.data);
        if (orderRes.data.length > 0) {
          // Use the shipping address from the latest order
          const lastAddress = orderRes.data[0].shipping_address;
          setAddress(lastAddress);
          setAddressForm(lastAddress);
        }
      } catch (err) {
        setUser(null);
        setOrders([]);
      }
      setLoading(false);
    };
    fetchData();
  }, [navigate]);

  // Address form handlers
  const handleAddressChange = (e) => {
    setAddressForm({ ...addressForm, [e.target.name]: e.target.value });
  };
  const saveAddress = () => {
    setAddress(addressForm);
    setEditAddress(false);
    // Optionally, send to backend to save as default address
  };

  // User form handlers
  const handleUserChange = (e) => {
    setUserForm({ ...userForm, [e.target.name]: e.target.value });
  };
  const saveUser = async () => {
    const token = localStorage.getItem("userToken");
    try {
      await axios.put(
        "https://sunrise-backend.sunrisemeditechsystems.com/api/users/myData",
        userForm,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setUser({ ...user, ...userForm });
      setEditUser(false);
    } catch (err) {
      // handle error
    }
  };

  const handleAccountOrderDetails = (id) => {
    setSelectId(id);
  };
    const goHome = () => {
 window.location.href ="https://sunrisemeditechsystems.com";
};

  return (
    <>
      {/* BREADCRUMB AREA START */}
      <div
        className="ltn__breadcrumb-area text-left bg-overlay-white-30 bg-image "
        data-bs-bg="img/bg/sunrise-medical.jpg"
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="ltn__breadcrumb-inner">
                <h1 className="page-title">My Account</h1>
                <div className="ltn__breadcrumb-list">
                  <ul>
                    <li>
                      <Link
                        to="#"
                        onClick={goHome}
                        className="bg-black-color"
                        style={{ cursor: "pointer" }}
                      >
                        <span className="ltn__secondary-color">
                          <i className="fas fa-home bg-black-color" />
                        </span>{" "}
                        Home
                      </Link>
                    </li>
                    <li>My Account</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* BREADCRUMB AREA END */}
      {/* WISHLIST AREA START */}
      <div className="liton__wishlist-area pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              {/* PRODUCT TAB AREA START */}
              <div className="ltn__product-tab-area">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="ltn__tab-menu-list mb-50">
                        <div className="nav">
                          <a
                            className="active show"
                            data-bs-toggle="tab"
                            href="#liton_tab_1_1"
                          >
                            Dashboard <i className="fas fa-home" />
                          </a>
                          <a data-bs-toggle="tab" href="#liton_tab_1_2">
                            Orders <i className="fas fa-file-alt" />
                          </a>
                          <a data-bs-toggle="tab" href="#liton_tab_1_3">
                            Downloads <i className="fas fa-arrow-down" />
                          </a>
                          <a data-bs-toggle="tab" href="#liton_tab_1_4">
                            address <i className="fas fa-map-marker-alt" />
                          </a>
                          <a data-bs-toggle="tab" href="#liton_tab_1_5">
                            Account Details <i className="fas fa-user" />
                          </a>
                          <a href="/logout" onClick={handleLogout}>
                            Logout <i className="fas fa-sign-out-alt" />
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-8">
                      <div className="tab-content">
                        <div
                          className="tab-pane fade active show"
                          id="liton_tab_1_1"
                        >
                          <div className="ltn__myaccount-tab-content-inner">
                            <p>
                              Hello <strong>{user ? user.name : "User"}</strong>{" "}
                              (not <strong>{user ? user.name : "User"}</strong>?{" "}
                              <small>
                                <a href="/logout" onClick={handleLogout}>
                                  Log out
                                </a>
                              </small>{" "}
                              )
                            </p>
                            <p>
                              From your account dashboard you can view your{" "}
                              <span>recent orders</span>, manage your{" "}
                              <span>shipping and billing addresses</span>, and{" "}
                              <span>
                                edit your password and account details
                              </span>
                              .
                            </p>
                          </div>
                        </div>
                        <div className="tab-pane fade" id="liton_tab_1_2">
                          <div className="ltn__myaccount-tab-content-inner">
                            <div className="table-responsive">
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th>Order</th>
                                    <th>Date</th>
                                    <th>Status</th>
                                    <th>Total</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {loading ? (
                                    <tr>
                                      <td colSpan="5">Loading...</td>
                                    </tr>
                                  ) : orders.length === 0 ? (
                                    <tr>
                                      <td
                                        colspan="5"
                                        className="text-center py-4 text-muted"
                                      >
                                        No orders found.
                                      </td>
                                    </tr>
                                  ) : (
                                    orders.map((order, idx) => (
                                      <tr key={order.id}>
                                        <td>{idx + 1}</td>
                                        <td>
                                          {new Date(
                                            order.created_at
                                          ).toLocaleDateString()}
                                        </td>
                                        <td>{order.status}</td>
                                        <td>₹{order.total_amount}</td>
                                        <td>
                                          <button
                                            className="btn btn-sm btn-outline-info"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target={`#order-details-${order.id}`}
                                            aria-expanded="false"
                                            aria-controls={`order-details-${order.id}`}
                                            onClick={() =>
                                              handleAccountOrderDetails(
                                                order.id
                                              )
                                            }
                                          >
                                            View
                                          </button>
                                        </td>
                                      </tr>
                                    ))
                                  )}
                                </tbody>
                              </table>
                              {/* Order details collapsible rows */}
                              {orders.map((order) => (
                                <div
                                  className="collapse"
                                  id={`order-details-${order.id}`}
                                  key={`details-${order.id}`}
                                >
                                  {order.id == selectId && (
                                    <div className="card card-body mb-3">
                                      <h6>Order Items:</h6>
                                      <ul>
                                        {order.items.map((item, i) => (
                                          <li
                                            key={i}
                                            name={console.log({ item })}
                                          >
                                            {item.name} × {item.quantity} (
                                            {item.buyOrRent}) — ₹
                                            {item.price?.toFixed(2)}
                                          </li>
                                        ))}
                                      </ul>
                                      <div>
                                        <strong>Shipping Address:</strong>
                                        <div>
                                          {order.shipping_address.firstName}{" "}
                                          {order.shipping_address.lastName},{" "}
                                          {order.shipping_address.address1},{" "}
                                          {order.shipping_address.city},{" "}
                                          {order.shipping_address.state},{" "}
                                          {order.shipping_address.zip}
                                        </div>
                                      </div>
                                      <div>
                                        <strong>Order Notes:</strong>{" "}
                                        {order.shipping_address.notes || "N/A"}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                        <div className="tab-pane fade" id="liton_tab_1_3">
                          <div className="ltn__myaccount-tab-content-inner">
                            <div className="table-responsive">
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th>Product</th>
                                    <th>Date</th>
                                    <th>Expire</th>
                                    <th>Download</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td colSpan="4" className="text-center">
                                      No downloads available.
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div className="tab-pane fade" id="liton_tab_1_4">
                          <div className="ltn__myaccount-tab-content-inner">
                            <p>
                              The following addresses will be used on the
                              checkout page by default.
                            </p>
                            <div className="row">
                              <div className="col-md-6 col-12 learts-mb-30">
                                <h4>
                                  Shipping Address{" "}
                                  <small>
                                    <a
                                      href="#"
                                      onClick={() => setEditAddress(true)}
                                    >
                                      edit
                                    </a>
                                  </small>
                                </h4>
                                {address ? (
                                  editAddress ? (
                                    <form
                                      onSubmit={(e) => {
                                        e.preventDefault();
                                        saveAddress();
                                      }}
                                    >
                                      <input
                                        type="text"
                                        name="firstName"
                                        value={addressForm?.firstName || ""}
                                        onChange={handleAddressChange}
                                        placeholder="First Name"
                                      />
                                      <input
                                        type="text"
                                        name="lastName"
                                        value={addressForm?.lastName || ""}
                                        onChange={handleAddressChange}
                                        placeholder="Last Name"
                                      />
                                      <input
                                        type="text"
                                        name="address1"
                                        value={addressForm?.address1 || ""}
                                        onChange={handleAddressChange}
                                        placeholder="Address"
                                      />
                                      <input
                                        type="text"
                                        name="city"
                                        value={addressForm?.city || ""}
                                        onChange={handleAddressChange}
                                        placeholder="City"
                                      />
                                      <input
                                        type="text"
                                        name="state"
                                        value={addressForm?.state || ""}
                                        onChange={handleAddressChange}
                                        placeholder="State"
                                      />
                                      <input
                                        type="text"
                                        name="zip"
                                        value={addressForm?.zip || ""}
                                        onChange={handleAddressChange}
                                        placeholder="Zip"
                                      />
                                      <button
                                        type="submit"
                                        className="btn theme-btn-1 btn-effect-1 text-uppercase"
                                      >
                                        Save
                                      </button>
                                    </form>
                                  ) : (
                                    <address className="border rounded p-3 bg-light">
                                      {address && address.firstName != null ? (
                                        <>
                                          <p className="mb-1">
                                            <strong>
                                              {address?.firstName}{" "}
                                              {address?.lastName}
                                            </strong>
                                          </p>
                                          <p className="mb-0">
                                            {address?.address1} <br />
                                            {address?.city}, {address?.state}{" "}
                                            {address?.zip}
                                          </p>
                                        </>
                                      ) : (
                                        <p>address not found</p>
                                      )}
                                    </address>
                                  )
                                ) : (
                                  <div>
                                    No address found. Please add your address.
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="tab-pane fade" id="liton_tab_1_5">
                          <div className="ltn__myaccount-tab-content-inner">
                            <div className="ltn__form-box">
                              {editUser ? (
                                <form
                                  onSubmit={(e) => {
                                    e.preventDefault();
                                    saveUser();
                                  }}
                                >
                                  <div className="row mb-50">
                                    <div className="col-md-6 mb-3">
                                      <label>Name:</label>
                                      <input
                                        type="text"
                                        name="name"
                                        value={userForm.name}
                                        onChange={handleUserChange}
                                      />
                                    </div>
                                    <div className="col-md-6">
                                      <label>Email:</label>
                                      <input
                                        type="email"
                                        name="email"
                                        value={userForm.email}
                                        onChange={handleUserChange}
                                      />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                      <label>Username:</label>
                                      <input
                                        type="text"
                                        name="username"
                                        value={userForm.username}
                                        onChange={handleUserChange}
                                      />
                                    </div>
                                    <div className="col-md-6">
                                      <label>Phone:</label>
                                      <input
                                        type="text"
                                        name="phone"
                                        maxLength="10"
                                        value={userForm.phone}
                                        onChange={handleUserChange}
                                      />
                                    </div>
                                    <div className="col-md-6">
                                      <label>Area:</label>
                                      <input
                                        type="text"
                                        name="area"
                                        value={userForm.area}
                                        onChange={handleUserChange}
                                      />
                                    </div>
                                  </div>

                                  <div className="btn-wrapper">
                                    <button
                                      type="submit"
                                      className="btn theme-btn-1 btn-effect-1 text-uppercase"
                                    >
                                      Save Changes
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-secondary ms-2"
                                      onClick={() => setEditUser(false)}
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </form>
                              ) : user ? (
                                <div>
                                  <p>
                                    <strong>Name:</strong> {user?.name}
                                  </p>
                                  <p>
                                    <strong>Email:</strong> {user?.email}
                                  </p>
                                  <p>
                                    <strong>Username:</strong> {user?.username}
                                  </p>
                                  <p>
                                    <strong>Phone:</strong> {user?.phone}
                                  </p>
                                  <p>
                                    <strong>Area:</strong> {user?.area}
                                  </p>
                                  <button
                                    className="btn theme-btn-1 btn-effect-1 text-uppercase"
                                    onClick={() => setEditUser(true)}
                                  >
                                    Edit
                                  </button>
                                </div>
                              ) : (
                                <p>User not found</p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* PRODUCT TAB AREA END */}
            </div>
          </div>
        </div>
      </div>
      {/* WISHLIST AREA START */}
    </>
  );
}
